'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _slicedToArray__default = /*#__PURE__*/_interopDefault(_slicedToArray);

var DEFAULT_DELIMITER = '/';
var DEFAULT_FIRST_INSTANCE = '2';
var DATE_DELMITERS = /[-/.]/;
var normalizeDate = function normalizeDate(dateToNormalize, dateFormat) {
  var normalized = dateToNormalize;
  var _ref = dateFormat.match(DATE_DELMITERS) || {
      0: DEFAULT_DELIMITER,
      index: DEFAULT_FIRST_INSTANCE
    },
    delimiter = _ref[0],
    firstInstance = _ref.index;

  // Try to handle dates that are entered without delimiters like 01012020
  if (dateToNormalize.length > 5 && !dateToNormalize.match(DATE_DELMITERS)) {
    // if date is entered in format mmddyy
    if (dateToNormalize.length === 6 && dateFormat.length <= 8) {
      var _dateToNormalize$spli = dateToNormalize.split(''),
        _dateToNormalize$spli2 = _slicedToArray__default.default(_dateToNormalize$spli, 6),
        d1 = _dateToNormalize$spli2[0],
        d2 = _dateToNormalize$spli2[1],
        d3 = _dateToNormalize$spli2[2],
        d4 = _dateToNormalize$spli2[3],
        d5 = _dateToNormalize$spli2[4],
        d6 = _dateToNormalize$spli2[5];
      normalized = "".concat(d1).concat(d2).concat(delimiter).concat(d3).concat(d4).concat(delimiter).concat(d5).concat(d6);
    }
    // if date is entered in format mmddyyyy
    else if (dateToNormalize.length === 8) {
      var _dateToNormalize$spli3 = dateToNormalize.split(''),
        _dateToNormalize$spli4 = _slicedToArray__default.default(_dateToNormalize$spli3, 8),
        _d = _dateToNormalize$spli4[0],
        _d2 = _dateToNormalize$spli4[1],
        _d3 = _dateToNormalize$spli4[2],
        _d4 = _dateToNormalize$spli4[3],
        _d5 = _dateToNormalize$spli4[4],
        _d6 = _dateToNormalize$spli4[5],
        d7 = _dateToNormalize$spli4[6],
        d8 = _dateToNormalize$spli4[7];
      if (firstInstance === 4) {
        normalized = "".concat(_d).concat(_d2).concat(_d3).concat(_d4).concat(delimiter).concat(_d5).concat(_d6).concat(delimiter).concat(d7).concat(d8);
      } else {
        normalized = "".concat(_d).concat(_d2).concat(delimiter).concat(_d3).concat(_d4).concat(delimiter).concat(_d5).concat(_d6).concat(d7).concat(d8);
      }
    }
  }
  return normalized;
};

exports.normalizeDate = normalizeDate;
//# sourceMappingURL=utils.js.map
